// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Fjk2p","valueRow":"styles_valueRow__Om4Z4","copyBtn":"styles_copyBtn__ClyiF"};